import { useMemo } from 'react';
import { ITableDemandItem } from '@models/winnerSelection/ITableDemand';
import { sortByPredefinedOrder } from '@utils/sortByPredefinedOrder';

export interface ICategoryGroup {
    name: string;
    crits: ITableDemandItem[];
    /** Сумма critWeight по группе. null если ни у одного крита нет веса. */
    totalWeight: number | null;
}

/**
 * Группирует критерии по категориям с подсчётом суммарного веса категории.
 * Сортировка категорий — по settings.categorySortOrder (custom order),
 * внутри категории info-критерии всегда после score-критериев.
 */
export function useGroupedCategories(
    items: ITableDemandItem[] | undefined,
    categorySortOrder?: string[],
): ICategoryGroup[] {
    return useMemo<ICategoryGroup[]>(() => {
        if (!items) return [];
        const map = new Map<string, ITableDemandItem[]>();
        items.forEach((it) => {
            const arr = map.get(it.category) || [];
            arr.push(it);
            map.set(it.category, arr);
        });
        return Array.from(map.entries())
            .sort(([a], [b]) => sortByPredefinedOrder(a, b, categorySortOrder))
            .map(([name, crits]) => {
                let totalWeight: number | null = null;
                for (const c of crits) {
                    if (c.critWeight != null) {
                        totalWeight = (totalWeight ?? 0) + c.critWeight;
                    }
                }
                return {
                    name,
                    crits: [...crits].sort((x, y) => Number(x.isInfoCrit) - Number(y.isInfoCrit)),
                    totalWeight,
                };
            });
    }, [items, categorySortOrder]);
}
